import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from '../../styles/printFont/vfs_fonts2';
import helper from "actions/helper";

const Print = async (infoPrint) => {
    const { vfs } = pdfFonts.pdfMake;
    pdfMake.vfs = vfs;

    pdfMake.fonts = {
        Roboto: {
            normal: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Regular.ttf',
            bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
            italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
            bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf'
        },
    };

    const getBody = () => {
        const body = [[
            { text: "Вопрос", fillColor: '#B6DCFA', bold: true },
            { text: "Ответ", alignment: 'center', fillColor: '#B6DCFA', bold: true }
        ]];

        const arr = infoPrint.type === 1 ? infoPrint.adultAnket : infoPrint.childAnket;

        arr.forEach(it => {
            const value = it.value ? it.value : it?.anketaQuestionAnswer?.title;
            body.push([
                it.question,
                value
            ]);
        });

        return body;
    };

    console.log("infoPrint", infoPrint);


    const documentDefinition = {
        pageSize: 'A4',
        content: [
            {
                style: 'header2',
                text: [{ text: "Анкета пациента", bold: true }]
            },
            {
                text: [
                    "Так как многие общие заболевания могут оказать влияние на процесс лечения у стоматолога, последующая ",
                    "информация является крайне важной.Кроме того, в процессе лечения применяются различные препараты и ",
                    "медикаменты, противопоказанные в некоторых случаях и при определенных общих заболеваниях.Неправильная ",
                    "информация может повредить вашему здоровью.Конфиденциальность ответов гарантируется."
                ],
                margin: [0, 0, 0, 10]
            },
            {
                style: 'client',
                text: [
                    "Пациент: ",
                    { text: `${infoPrint.fio} ${infoPrint?.birthday ? "(" + helper.date.toStr(infoPrint.birthday, "DD.MM.YYYY") + ")" : ""}`, bold: true, },
                ]
            },
            {
                style: 'client',
                text: [
                    "Телефон: ",
                    { text: `${helper.inputValidators.phone(infoPrint.phone)}`, bold: true, },
                ]
            },
            {
                text: [
                    "О своем состоянии здоровья сообщаю следующее:"
                ],
                margin: [0, 10, 0, 5]
            },
            {
                style: 'itogo',
                table: {
                    headerRows: 1,
                    widths: ['*', 120],
                    body: getBody(),
                    dontBreakRows: true,
                    keepWithHeaderRows: 1
                }
            },
            {
                text: [
                    "Я знаю, что в случае приема лекарственных препаратов до начала приема стоматолога, должен(на) сообщить об ",
                    "этом врачу, так же, как и обо всех изменениях в состоянии моего здоровья. "
                ],
                margin: [0, 0, 0, 5]
            },
            {
                text: [
                    "Я даю разрешение моему доктору делать рентгеновские снимки, диагностические модели и проводить любые ",
                    "другие диагностические мероприятия, которые доктор найдет необходимыми для тщательного диагноза моих нужд."
                ],
                margin: [0, 0, 0, 5]
            },
            {
                text: [
                    "Я также даю разрешение проводить необходимые мероприятия, прописывать необходимые по показаниям ",
                    "лекарства и разрешаю доктору использовать любого ассистента, участие которого в моем лечении он сочтет необходимым."
                ],
                margin: [0, 0, 0, 5]
            },
            {
                text: [
                    "Я понимаю, что ответственен(а) за оплату услуг, оказанных мне в данном лечебном заведении. "
                ],
                margin: [0, 0, 0, 15]
            },
            {
                text: [
                    "Подпись пациента ФИО________ "
                ],
                margin: [0, 0, 0, 5]
            },
            {
                style: 'doctor',
                text: [
                    "Сформировано: ",
                    helper.date.toStr(new Date(), "DD.MM.YYYY")
                ],
                margin: [0, 0, 0, 10]
            },

        ],
        styles: {
            header: {
                fontSize: 9,
                lineHeight: 0.7,
                margin: [0, 10, 0, 20]
            },
            header2: {
                fontSize: 12,
                alignment: 'center',
                margin: [0, 0, 0, 15]
            },
            client: {
            },
            doctor: {
                margin: [0, 0, 0, 15]
            },
            table: {
                fontSize: 9,
            },
            itogo: {
                fontSize: 10,
                margin: [0, 15, 0, 15]
            },
            itogoTable: {
            },
            itogoTable2: {
            },
            signTable: {
                margin: [0, 20, 0, 0]
            },
        },
        defaultStyle: {
            fontSize: 10,
        }
    };

    pdfMake.createPdf(documentDefinition).open();

};

export default Print;
